import styled from 'styled-components';
import { colors, breakPoints, toRgba } from '@/styles';

export const NotebookList = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  border-radius: 5px;
  border-style: hidden; /* hide standard table (collapsed) border */
  box-shadow: 0 0 0 1px ${colors.secondary.lightGray3};

  thead {
    background: ${colors.secondary.lightGray1};
    th {
      border-radius: 5px;
      text-align: left;
      padding: 10px;
    }
  }

  th,
  td {
    padding: 10px;
    &:last-child {
      width: 30px;
      text-align: right;
    }
  }

  tr {
    border: 1px solid ${colors.secondary.lightGray3};
  }
  td {
    /* border: 1px solid ${colors.secondary.lightGray3}; */
  }
`;

export const CommitDiff = styled.div`
  @media (max-width: ${breakPoints.mobile}) {
    display: none;
  }
`;

export const RowCountIndicator = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 3px 5px;
  border-radius: 5px;
  border: none;

  &.rows-added {
    background: ${toRgba(colors.semantic.diff.added.indicator, 0.15)};
    color: ${colors.semantic.diff.added.indicator};
  }
  &.rows-removed {
    background: ${toRgba(colors.semantic.diff.removed.indicator, 0.1)};
    color: ${colors.semantic.diff.removed.indicator};
  }
  &.rows-modified {
    background: ${toRgba(colors.semantic.diff.modified.indicator, 0.15)};
    color: ${colors.semantic.diff.modified.indicator};
  }
`;
